import React from 'react';
import styled from 'styled-components';

const PrivacyWrapper = styled.section`
  padding: 50px 20px;
  max-width: 800px;
  margin: 0 auto;
`;

const PrivacyTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
`;

const PrivacyText = styled.p`
  font-size: 1.2rem;
  line-height: 1.6;
`;

const PrivacyPolicy = () => (
  <PrivacyWrapper>
    <PrivacyTitle>Privacy Policy</PrivacyTitle>
    <PrivacyText>
      <strong>1. Introduction</strong><br />
      Cloudetica Solutions ("we", "us", or "our") is committed to protecting the privacy of our clients, users, and visitors. This Privacy Policy outlines how we collect, use, disclose, and protect your personal information in accordance with the Privacy Act 1988 (Cth) and the Australian Privacy Principles (APPs).

      <br /><br />
      <strong>2. Information We Collect</strong><br />
      We may collect personal information such as your name, contact details, email address, and other relevant information when you engage our services, visit our website, or interact with us in other ways. This information may be collected directly from you or from third parties with your consent.

      <br /><br />
      <strong>3. How We Use Your Information</strong><br />
      The personal information we collect is used to:
      <ul>
        <li>Provide and manage our consulting services;</li>
        <li>Communicate with you about our services and respond to your inquiries;</li>
        <li>Process payments and manage accounts;</li>
        <li>Improve our website, services, and client experience;</li>
        <li>Comply with legal and regulatory obligations.</li>
      </ul>

      <br /><br />
      <strong>4. Disclosure of Your Information</strong><br />
      We may disclose your personal information to:
      <ul>
        <li>Our employees and contractors, only as necessary to deliver our services;</li>
        <li>Third-party service providers, such as payment processors, IT support, and cloud service providers;</li>
        <li>Legal, financial, and other professional advisors;</li>
        <li>Regulatory bodies, government agencies, or as required by law.</li>
      </ul>
      We do not sell, rent, or trade your personal information to third parties for marketing purposes.

      <br /><br />
      <strong>5. Data Security</strong><br />
      We take reasonable steps to protect your personal information from misuse, interference, loss, unauthorized access, modification, or disclosure. This includes implementing physical, electronic, and managerial security measures.

      <br /><br />
      <strong>6. Access and Correction</strong><br />
      You have the right to access and correct your personal information held by us. If you believe any information we hold about you is inaccurate, outdated, or incomplete, please contact us to request a correction.

      <br /><br />
      <strong>7. Cross-Border Disclosure</strong><br />
      Your personal information may be stored or processed outside Australia. We ensure that any overseas recipients of your information are bound by obligations that provide a level of protection that is substantially similar to the protection under Australian law.

      <br /><br />
      <strong>8. Cookies and Tracking Technologies</strong><br />
      Our website may use cookies and similar tracking technologies to enhance your experience and gather information about site usage. You can adjust your browser settings to refuse cookies, but this may affect the functionality of our website.

      <br /><br />
      <strong>9. Changes to This Policy</strong><br />
      We may update this Privacy Policy from time to time to reflect changes in our practices or legal obligations. The updated policy will be posted on our website, and we encourage you to review it periodically.

      <br /><br />
      <strong>10. Contact Us</strong><br />
      If you have any questions or concerns about our Privacy Policy or the handling of your personal information, please contact us at:
      <br />
      Email: agung@cloudetica.com
      <br />
    </PrivacyText>
  </PrivacyWrapper>
);

export default PrivacyPolicy;
